import { render, staticRenderFns } from "./Add.vue?vue&type=template&id=2ec8cabc&"
import script from "./Add.vue?vue&type=script&lang=js&"
export * from "./Add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tanglewang/htdocs/yqd/yqdSaaS/yqdshop_h5/node_modules/_vue-hot-reload-api@2.3.4@vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ec8cabc')) {
      api.createRecord('2ec8cabc', component.options)
    } else {
      api.reload('2ec8cabc', component.options)
    }
    module.hot.accept("./Add.vue?vue&type=template&id=2ec8cabc&", function () {
      api.rerender('2ec8cabc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/address/Add.vue"
export default component.exports